import { render } from "./PolarChart.vue?vue&type=template&id=2a5e71b5"
import script from "./PolarChart.vue?vue&type=script&lang=js"
export * from "./PolarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__